import { render } from "./SberId.vue?vue&type=template&id=05215108&scoped=true&ts=true"
import script from "./SberId.vue?vue&type=script&lang=ts"
export * from "./SberId.vue?vue&type=script&lang=ts"

import "./SberId.vue?vue&type=style&index=0&id=05215108&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05215108"]])

export default __exports__